module.exports = "/static/Images/es/Nine.png";